/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { makeStyles } from 'tss-react/mui';
import * as React from 'react';
const styles = (theme) => ({
    wrapper: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "10px",
        padding: "5px 10px",
        width: "100%"
    },
    label: {
      fontFamily: theme.typography.fontFamily,
        display: "flex",
        flex: 1,
    },
    input: {
      fontFamily: theme.typography.fontFamily,
        display: "flex",
        flex: 2,
        border: "1px solid #999",
        paddingTop: "7px",
        paddingBottom: "7px",
        paddingLeft: "10px",
        paddingRight: "10px",
        fontSize: "16px",
        borderRadius: "5px",
        minWidth: "70%"
    }
});

const useStyles = makeStyles()(styles)

export default function FileInput({
  accept,
  label,
  onChange,
  'data-test-id': dataTestId,
}) {
const { classes }= useStyles();
  return (
    <div className={classes.wrapper}>
      <label className={classes.label}>{label}</label>
      <input
        type="file"
        accept={accept}
        className={classes.input}
        onChange={(e) => onChange(e.target.files)}
        data-test-id={dataTestId}
      />
    </div>
  );
}
